'use client';

import { FC } from 'react';

import { useTranslation } from '@/hooks/useTranslations';

import './style.scss';

type YoSlotRowProps = {
  label: string;
  value: {
    value: string;
    options?: any;
  };
  description: {
    value: string;
    options?: any;
  };
  isOptional?: boolean;
};

const YoSlotRow: FC<YoSlotRowProps> = ({ label, value, description, isOptional = false }) => {
  const { t } = useTranslation();

  return (
    <div className="land-based-slot-info-row">
      <div className="land-based-slot-info-left-wrp">
        <p
          className={`l-b-slot-left-title ${!value.value && !description.value ? 'l-b-slot-left-opt' : ''}`}
        >
          {t(label)}
        </p>
        {isOptional && (
          <p className="l-b-slot-left-opt">{t('LandBased-Yoslot 43-Topper-title-optional')}</p>
        )}
      </div>
      <div className="land-based-slot-info-right-wrp">
        <p className="l-b-slot-right-title">{t(value.value, value.options)}</p>
        <p className="l-b-slot-right-title">{t(description.value, description.options)}</p>
      </div>
    </div>
  );
};

export default YoSlotRow;
